<template>
    <div>
        <!-- eslint-disable vue/no-v-html -->
        <div class="w-100">
            <faq v-for="(faq, index) in searchResults" :key="index" :question-number="index + 1">
                <template #question="slotProps">
                    <!-- //NOSONAR --><span :class="{ 'text-primary': slotProps.answerShowing }" v-html="faq.question">
                    </span>
                </template>
                <template #answer> <!-- //NOSONAR --><span v-html="faq.answer"></span> </template>
            </faq>
        </div>
        <!-- eslint-enable vue/no-v-html -->

        <div v-if="!searchResults.length" class="no-results p-5 text-center">
            Sorry. No results were found for the question you entered. Please try again or call customer service at
            <a href="tel:800-217-4800">800-217-4800</a>
        </div>
    </div>
</template>

<script>
import Faq from "../components/Faq";
import GooglePlayIcon from "../images/google-play.png";
import AppStoreIcon from "../images/appstore.png";
import lodashIsEmpty from "lodash/isEmpty";
export default {
    name: "FaqList",
    components: { Faq },
    data() {
        const phoneNumbers = {
            personalShopper: "(800) 217-4800",
            carsaverSpecialist: "(800) 217-4800",
            claimsDepartment: "(866) 753-0941",
            carsaverMainOffice: "(888) 965-1120",
        };

        return {
            searchTerm: "",
            faqs: [
                {
                    question: "WHAT IF I HAVE QUESTIONS ABOUT THE PROGRAM PRIOR TO BUYING MY VEHICLE?",
                    answer:
                        "Contact a CarSaver " +
                        this.$t("deal.shopperText") +
                        "at" +
                        `<a href="tel:${phoneNumbers.personalShopper}">${phoneNumbers.personalShopper}</a>.`,
                },
                {
                    question: "WHAT DOES THE LIFETIME WARRANTY COVER?",
                    answer:
                        "It provides coverage to the engine, transmission and drive axle components for as long as" +
                        " you own the vehicle.",
                },
                {
                    question: "WHAT’S THE CATCH?",
                    answer:
                        "There is no catch; this Lifetime Warranty is provided to you at no cost at the time of " +
                        "purchase of a qualifying vehicle through an appointment with CarSaver",
                },
                {
                    question: "CAN THE LIFETIME WARRANTY BE TRANSFERRED TO A SUBSEQUENT OWNER?",
                    answer: "No, the Lifetime Warranty is not eligible for transfer.",
                },
                {
                    question: "IS THE LIFETIME WARRANTY AVAILABLE TO PURCHASE FOR OTHER VEHICLES?",
                    answer:
                        "No, the CarSaver Lifetime Warranty is only available on qualifying vehicles from " +
                        "a CarSaver Certified Dealer™ at the time of purchase. " +
                        "Visit <a href='https://www.carsaver.com'>www.CarSaver.com</a> " +
                        "for complete details on the CarSaver Lifetime Warranty coverage.",
                },
                {
                    question: "WHERE CAN I HAVE MAINTENANCE PERFORMED?",
                    answer:
                        "It is recommended that you return to the CarSaver Certified Dealership™ where you " +
                        "purchased your vehicle. If you are not near your selling dealer, " +
                        "you may have maintenance performed at another CarSaver Certified Dealer™ or professional " +
                        "repair facility. If you have any additional questions, you " +
                        "can contact a CarSaver specialist at " +
                        `<a href='tel:${phoneNumbers.carsaverSpecialist}'>${phoneNumbers.carsaverSpecialist}</a>.`,
                },
                {
                    question: "HOW DO I KNOW WHAT MAINTENANCE IS REQUIRED TO KEEP THE LIFETIME WARRANTY ACTIVE?",
                    answer:
                        "<p>" +
                        "Customary maintenance is required and includes changing the engine oil and filter, " +
                        "checking and maintaining the transmission fluid level, topping " +
                        "off all fluid levels, and checking and maintaining the proper level of coolant.</p>" +
                        "<p>Maintenance is required by oil type and is defined as follows:</p>" +
                        "<div><strong>Conventional Oil:</strong> The vehicle must be serviced at least every 6 " +
                        "months OR 7,500 miles, whichever comes first.</div>" +
                        "<div><strong>Synthetic / Synthetic Blend Oil:</strong> The vehicle must be serviced at " +
                        "least every 12 months OR 10,000 miles, whichever comes first.</div>",
                },
                {
                    question: "WHY IS MY DEALERSHIP SUGGESTING ADDITIONAL MAINTENANCE SERVICES?",
                    answer:
                        "Manufacturers require a minimum level of services and will often state this in " +
                        "the owner’s manual. Your driving style and environmental conditions " +
                        "will impact the level of service work required to keep your vehicle performing " +
                        "at peak levels. While you are only required to perform the customary " +
                        "maintenance outlined in your agreement, we strongly encourage you to follow your " +
                        "dealership’s recommendations when being offered additional services.",
                },
                {
                    question: "HOW DOES CARSAVER KNOW WHEN I HAVE MAINTENANCE PERFORMED?",
                    answer:
                        "You are required to keep records of all maintenance performed on your vehicle. Record of " +
                        "maintenance must include the vehicle identification number (VIN), " +
                        "description of the vehicle, date of service, and your vehicle’s mileage. For your " +
                        "convenience, the CarSaver Protect app allows you to save all records " +
                        "associated with your vehicle.",
                },
                {
                    question:
                        "WHAT IF I EXCEED THE TIME OR MILEAGE INTERVALS LISTED IN MY AGREEMENT FOR CUSTOMARY" +
                        " MAINTENANCE?",
                    answer: "The program provides a grace period of 1 month OR 1,000 miles, whichever comes first.",
                },
                {
                    question: "CAN I PERFORM MY OWN MAINTENANCE?",
                    answer:
                        "No, all services must be performed at a CarSaver Certified Dealership™ or at a professional " +
                        "repair facility.",
                },
                {
                    question: "WHAT IS A PROFESSIONAL REPAIR FACILITY?",
                    answer:
                        "Any repair facility that has a license to do business and can provide a detailed repair" +
                        " order that contains all of the pertinent information regarding the services performed.",
                },
                {
                    question: "HOW DO I MAKE A CLAIM IF I HAVE A BREAKDOWN?",
                    answer:
                        "Take your vehicle to your selling dealer or the nearest CarSaver Certified Dealer™. " +
                        "If that is not possible, you can contact our claims department at " +
                        `<a href='tel:${phoneNumbers.claimsDepartment}'>${phoneNumbers.claimsDepartment}</a>.` +
                        "Our claim specialists are available Monday - Friday 8 a.m. - 8 p.m. " +
                        "Eastern Time and Saturday 9 a.m. - 5 p.m. " +
                        "Eastern Time to answer all your questions. Prior to any repair or replacement being " +
                        "made, you must contact our claims department to obtain authorization. If " +
                        "an emergency occurs which requires a repair to be made at the time when our office is " +
                        "closed, and prior authorization cannot be obtained, contact us during " +
                        "normal business hours immediately following the emergency repair.",
                },
                {
                    question: "IS THERE A DEDUCTIBLE THAT I NEED TO PAY WHEN I HAVE A COVERED CLAIM?",
                    answer:
                        "There is no deductible on the Lifetime Warranty. All parts and labor repair " +
                        "costs are covered 100%.",
                },
                {
                    question:
                        "IF MY VEHICLE BREAKS DOWN AND THE BREAKDOWN IS COVERED BY THE AGREEMENT, " +
                        "AM I REQUIRED TO PAY FOR THE REPAIR AND THEN WAIT TO BE REIMBURSED?",
                    answer:
                        "No, all repairs are paid by CarSaver directly to the service department immediately " +
                        "after the repairs are completed.",
                },
                {
                    question: "WHAT IF I EXPERIENCE A BREAKDOWN PRIOR TO RECEIVING MY AGREEMENT?",
                    answer:
                        "You are still covered. Simply contact CarSaver at " +
                        `<a href='tel:${phoneNumbers.carsaverMainOffice}'>${phoneNumbers.carsaverMainOffice}</a> ` +
                        "and a CarSaver specialist will be able to assist you.",
                },
                {
                    question: "WHAT IF I NEED TO BE TOWED OR NEED A RENTAL VEHICLE WHILE MY VEHICLE IS BEING REPAIRED?",
                    answer:
                        "Your CarSaver Lifetime Warranty agreement does not provide roadside or rental vehicle " +
                        "assistance. However, if you purchased a CarSaver Protection Plus+ agreement, " +
                        "roadside and rental vehicle assistance is provided for the term of the CarSaver " +
                        "Protection Plus+ agreement.",
                },
                {
                    question: "WHAT IS THE LIFETIME WARRANTY LIMIT OF LIABILITY?",
                    // eslint-disable-next-line vue/max-len
                    answer:
                        "The limit of liability is the NADA average retail " +
                        "value of the vehicle at the time of claim.",
                },
                {
                    question: "WILL I LOSE MY COVERAGE IF I USE MY VEHICLE AS PART OF A RIDESHARING SERVICE?",
                    // eslint-disable-next-line vue/max-len
                    answer:
                        "No, the Lifetime Warranty allows you to use " +
                        "your vehicle as part of a ridesharing service.",
                },
                {
                    question: "IS THE LIFETIME WARRANTY INSURED?",
                    answer: 'The program is backed by an "A" rated insurance company.',
                },
                {
                    question: "HOW DO I REGISTER MY VEHICLE WITH THE CARSAVER LIFETIME WARRANTY?",
                    answer:
                        "You can download the CarSaver Protect app, " +
                        "visit <a href='https://www.carsaver.com/protect'>www.carsaver.com/protect</a> or call us at " +
                        `<a href='tel:${phoneNumbers.carsaverSpecialist}'>${phoneNumbers.carsaverSpecialist}</a> ` +
                        "and one of our CarSaver specialists will assist you.",
                },
                {
                    question: "WHEN WILL I RECEIVE MY AGREEMENT?",
                    answer:
                        "You should receive your agreement within 30 days following the purchase of your " +
                        "vehicle and the registration of your agreement. The agreement " +
                        "will be sent to you from CarSaver electronically at the email address you provided to " +
                        "the dealership at the time of purchase. A physical copy will " +
                        "also be sent in a welcome packet via US Postal Service. If you do not receive agreement " +
                        "within 30 days of registration, contact CarSaver at " +
                        `<a href='tel:${phoneNumbers.carsaverMainOffice}'>${phoneNumbers.carsaverMainOffice}</a>.`,
                },
                {
                    question: "WHAT IF I LOSE MY AGREEMENT PAPERWORK?",
                    answer:
                        "You can access your agreement information by downloading the CarSaver Protect app. " +
                        "For additional information, please contact our office at " +
                        `<a href='tel:${phoneNumbers.carsaverMainOffice}'>${phoneNumbers.carsaverMainOffice}</a>.`,
                },
                {
                    question: "WHERE CAN I FIND THE CARSAVER PROTECT APP?",
                    answer:
                        "The CarSaver Protect app is available for download on compatible iOS and Android devices. " +
                        "To download the app, visit the Apple App Store or Google Play " +
                        'store and search "CarSaver Protect". You can also download the apps here:' +
                        `<div class="mt-3">${this.getPlayStoreLinkHtml()}</div>` +
                        `<div class="mt-3">${this.getAppStoreLinkHtml()}</div>`,
                },
            ],
        };
    },

    computed: {
        searchResults() {
            /*
            Matches term and captures the match. Dont match html tags
            because they are invisible and highlighting will break
            them.
            */
            const matchingSearchTerm = new RegExp(`(${this.searchTerm})(?![^<]*?>)`, "gi");

            const faqMatchesSearchTerm = (faq) =>
                lodashIsEmpty(this.searchTerm) ||
                matchingSearchTerm.test(faq.question) ||
                matchingSearchTerm.test(faq.answer);

            /*
            Uses regex (capture group $1) for highlighting so that the
            original phrase will be highlighted not the search term one
            since case can differ
             */
            const highlightSearchTerm = (text) => {
                if (lodashIsEmpty(this.searchTerm)) {
                    return text;
                } else {
                    return text.replace(matchingSearchTerm, '<span class="highlighter">$1</span>');
                }
            };

            const resultWithHighlighting = (faq) => {
                return {
                    question: highlightSearchTerm(faq.question),
                    answer: highlightSearchTerm(faq.answer),
                };
            };

            return this.faqs.filter(faqMatchesSearchTerm).map(resultWithHighlighting);
        },
    },

    methods: {
        getPlayStoreLinkHtml() {
            return `<a href="https://play.google.com/store/apps/details?id=com.carsaver.connect">
                    <img src="${GooglePlayIcon}" alt="Google Play Store download link for CarSaver Protect App" ></a>`;
        },
        getAppStoreLinkHtml() {
            return `<a href="https://itunes.apple.com/us/app/carsaver-protect/id1229852030">
                    <img src="${AppStoreIcon}" alt="Apple App Store download link for CarSaver Protect App" ></a>`;
        },
    },
};
</script>

<style lang="scss">
.highlighter {
    background-color: yellow;
}
.no-results {
    background-color: $gray-100;
    color: $gray-800;
    font-size: px2rem(16);
}
</style>
